import React, { useState } from "react";
import { faKey, faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "components/base/Button";
import Section from "components/base/Section";
import ChangePasswordModal from "components/modals/ChangePasswordModal";
import SellerProfileManager from "components/modules/seller/SellerProfileManager";
import { useAuth } from "providers/AuthProvider";
import { Alert } from "react-bootstrap";

const SellerProfile = () => {
  const { seller } = useAuth();
  const [showModal, setShowModal] = useState(false);

  if (!seller) return null;

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);
  
  const isPendingSeller = seller?.is_seller === "0";

  return (
    <div className="pt-5">
      <Section small className="py-0">
        {/* Pending Seller Banner */}
        {isPendingSeller && (
          <Alert variant="warning" className="mb-4">
            <div className="d-flex align-items-center">
              <FontAwesomeIcon icon={faExclamationTriangle} className="me-3 fs-4" />
              <div>
                <h5 className="alert-heading mb-1">Your account is pending approval</h5>
                <p className="mb-0">
                  Please complete all required documentation in the Documents tab below. 
                  Once submitted, your account will be reviewed by our admin team.
                  You'll have limited access until your account is approved.
                </p>
              </div>
            </div>
          </Alert>
        )}
      
        {/* Password Button */}
        <div className="text-end mb-4">
          <Button 
            variant="outline-primary" 
            className="me-2"
            onClick={handleShowModal}
          >
            <FontAwesomeIcon icon={faKey} className="me-2" />
            Change Password
          </Button>
        </div>

        {/* Integrated Profile Manager Component */}
        <SellerProfileManager defaultDocTab={isPendingSeller} />
      </Section>

      <ChangePasswordModal show={showModal} handleClose={handleCloseModal} />
    </div>
  );
};

export default SellerProfile;
